import React, { useContext, useEffect, useState } from 'react';
import { useHistory, withRouter } from 'react-router-dom';
import { isMobile } from 'react-device-detect';
import { findAllUsers, removeUser } from '../../models/actions/Users';
import '../../App.css';
import compose from 'recompose/compose';
import SpIconAndTextButton from '../../components/atoms/SpIconAndTextButton';
import SpText from '../../components/atoms/SpText';
import SpButton from '../../components/atoms/SpButton';
import SpIconButton from '../../components/atoms/SpIconButton';
import SpSearch from '../../components/atoms/SpSearch';
import { SpTable, SpTableCell, SpTableRow } from '../../components/bundles/SpTable';
import { styled } from '../../components/styled';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import { Grid, TableCell } from '@material-ui/core';
import { labels } from '../shared/translations';
import { withSnackbar } from '../../components/atoms/SpSnackBar';
import { ArrowBack, DeleteForever } from '@material-ui/icons';
import SpDialog from '../../components/atoms/SpDialog';
import { theme } from '../../components/theme';
import moment from 'moment';
import { UserSessionContext } from '../../App';

const UsersAdminList = (props) => {
  const [currentPatient, setCurrentPatient] = useState();
  const [searchString, setSearchString] = useState();
  const [usersList, setUsers] = useState([]);
  const [displayUsers, setDisplayUsers] = useState([]);
  const [openDeleteUser, setOpenDeleteUser] = useState({ status: false, data: null });
  const { authData, setAuthData } = useContext(UserSessionContext);

  const history = useHistory();

  const fetchData = async () => {
    props.isLoading(true);
    try {
      const response = await findAllUsers(null, authData.accessToken);
      if (response) {
        const newArray = response.filter((s) => s.type != 'ADMIN' && s.device_os !== 'android' && s.device_os !== 'ios');
        setUsers(newArray);
        setDisplayUsers(newArray);
      }
    } catch (error) {
      props.snackbarShowErrorMessage(error);
    }
    props.isLoading(false);
  };

  const filterUsers = (e) => {
    let newDisplayFilters = usersList?.filter((row) => row.name.trim().toLowerCase().includes(e.currentTarget.value.toString().trim().toLowerCase()));
    setDisplayUsers(newDisplayFilters);
    if (e.currentTarget.value === '') setDisplayUsers(usersList);
    setSearchString(e.currentTarget.value);
  };

  useEffect(() => {
    fetchData();
  }, []);

  const removeUserById = async (userData) => {
    try {
      let response = await removeUser({ id_user: userData.data.id }, authData.accessToken);
      if (response?.message) {
        setOpenDeleteUser({ status: false, data: null });
        fetchData();
        props.snackbarShowMessage(response.message);
      } else {
        props.snackbarShowErrorMessage(response.error);
      }
    } catch (error) {
      props.snackbarShowErrorMessage(error);
    }
  };

  const headCells = [
    {
      id: 'users',
      numeric: false,
      disablePadding: false,
      label: labels.groups.table.header.name,
      isAction: false
    },
    {
      id: 'professionals',
      numeric: false,
      disablePadding: false,
      label: labels.groups.table.header.addingDate,
      isAction: false
    },
    {
      id: 'actions',
      numeric: false,
      disablePadding: false,
      label: labels.groups.table.header.actions,
      isAction: true
    }
  ];

  const TitleToolbarSection = styled('div')({
    display: 'flex',
    flex: 1,
    alignItems: 'center',
    justifyContent: 'flex-start'
  });

  //rendering the profile editing form
  const UserRow = ({ row, rowKey, index, handleSelectedClick }) => {
    return (
      <>
        <SpTableRow
          role="checkbox"
          id={row?.group?.id}
          tabIndex={index}
        >
          <SpTableCell>
            <SpIconAndTextButton
              isIconRight={true}
              textVariant="tableText"
              text={row.name}
              onClick={() => history.push(`/admin/users/edit/${row?.id}`)}
            >
              <ArrowForwardIosIcon style={{ width: 10, color: theme.colors.mainGreen.main, height: 30, cursor: 'pointer' }} />
            </SpIconAndTextButton>
          </SpTableCell>
          <SpTableCell>
            <SpText variant="tableText">{moment(row.createdAt).format('DD/MM/yyyy')}</SpText>
          </SpTableCell>
          <TableCell
            align={'right'}
            style={{
              padding: 0,
              verticalAlign: 'bottom',
              borderBottom: 0
            }}
          >
            <SpIconButton
              variant={'standard'}
              type="tableList"
              text={''}
              onClick={() => {
                setOpenDeleteUser({ status: true, data: row });
              }}
            >
              <DeleteForever />
            </SpIconButton>
          </TableCell>
        </SpTableRow>
      </>
    );
  };

  return (
    <>
      <Grid
        container
        style={{ paddingLeft: '1%' }}
        direction="column"
        spacing={2}
      >
        <Grid
          item
          xs={12}
        >
          <TitleToolbarSection>
            <SpText
              variant="h1"
              style={{ marginRight: '5px' }}
            >{`UTENTI`}</SpText>
          </TitleToolbarSection>
        </Grid>
        <Grid
          item
          container
          xs={12}
          direction="row"
          spacing={3}
          alignItems="center"
        >
          <Grid
            item
            xs={7}
          >
            <SpSearch
              onChange={(e) => filterUsers(e)}
              value={searchString}
              searchStyle={{ width: '100%' }}
              style={{ marginRight: '5px' }}
            />
          </Grid>
          <Grid
            item
            xs={5}
          >
            <SpButton
              buttonType={'accept'}
              onClick={() => history.push('/admin/users/edit')}
              text={'Aggiungi utente'}
              style={{ marginLeft: '10%' }}
            />
          </Grid>
        </Grid>
        {displayUsers && displayUsers?.length === 0 && (
          <Grid
            container
            item
            xs={12}
            style={{ marginTop: '1%' }}
          >
            <SpText variant="h1PageSubtitle">Non ci sono utenti!</SpText>
          </Grid>
        )}
        {displayUsers && displayUsers?.length > 0 && (
          <Grid
            item
            xs={12}
          >
            <SpTable
              pagination={true}
              headCells={headCells}
              rows={displayUsers}
              rowKey="id"
              padding={false}
              notCheckable={false}
              tableContainerMaxHeight={isMobile ? 'calc(100vh - 300px)' : 'calc(100vh - 320px)'}
            >
              <UserRow />
            </SpTable>
          </Grid>
        )}
      </Grid>
      <SpDialog
        style={{ padding: '1%' }}
        open={openDeleteUser.status}
        setOpen={() => setOpenDeleteUser({ status: !openDeleteUser.status, data: null })}
        title={'Elimina utente'}
      >
        <Grid
          container
          direction="column"
          spacing={2}
        >
          <Grid
            item
            xs={12}
          >
            <SpText variant="text">{"Sei sicuro di voler eliminare l'utente?"}</SpText>
          </Grid>
          <Grid
            item
            container
            xs={12}
            alignItems={'flex-start'}
          >
            <Grid
              item
              xs={4}
            >
              <SpButton
                text={'SI'}
                buttonType="accept"
                onClick={() => removeUserById(openDeleteUser)}
              />
            </Grid>
            <Grid
              item
              xs={4}
              style={{ marginBottom: '1%' }}
            >
              <SpButton
                text={'NO'}
                buttonType="accept"
                onClick={() => setOpenDeleteUser(false)}
              />
            </Grid>
          </Grid>
        </Grid>
      </SpDialog>
    </>
  );
};
export default compose(withSnackbar, withRouter)(UsersAdminList);
